import { render } from "./ImportFile.vue?vue&type=template&id=1f60d71e"
import script from "./ImportFile.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportFile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Products/ImportFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f60d71e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f60d71e', __exports__)) {
    api.reload('1f60d71e', __exports__)
  }
  
  module.hot.accept("./ImportFile.vue?vue&type=template&id=1f60d71e", () => {
    api.rerender('1f60d71e', render)
  })

}


export default __exports__